import { AppThunkAction } from "..";
import { KnownAction, RECEIVE_INFOGRAPHICS_DATA, SHOW_LOADER } from "./types";
import * as services from "../service";

export const actionCreators = {
    getInfographicsRssFeedData:
        (userType: string): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const state = getState();
            if (state.infographicsState && state.infographicsState.infographicsData != null && state.infographicsState.infographicsData.length < 1) {
                dispatch({ type: SHOW_LOADER, isLoading: true });
                services
                    .getRSSFeed("1", userType + "-resources", "infographics")
                    .then((data) => {
                        dispatch({ type: RECEIVE_INFOGRAPHICS_DATA, infographicsData: data });
                        dispatch({ type: SHOW_LOADER, isLoading: false });
                    })
                    .catch(function (error) {
                        const temp = error;
                        dispatch({ type: SHOW_LOADER, isLoading: false });
                    });
            }
        },
};
